import {
    VIEW_AS_CLIENT_KEY,
    SELECTED_CLIENT_ID_KEY,
    SELECTED_CLIENT_NAME_KEY,
} from '@/viewAsClient';

/**
 * Service for managing client view context
 * Handles "View as Client" mode and selected client data in localStorage
 */
class ClientViewService {
    /**
     * Checks if "View as Client" mode is enabled
     */
    isViewAsClient(): boolean {
        return sessionStorage.getItem(VIEW_AS_CLIENT_KEY) === 'true';
    }

    /**
     * Sets "View as Client" mode
     */
    setViewAsClient(value: boolean): void {
        if (value) {
            sessionStorage.setItem(VIEW_AS_CLIENT_KEY, 'true');
        } else {
            sessionStorage.removeItem(VIEW_AS_CLIENT_KEY);
        }
    }

    /**
     * Gets the selected client ID
     */
    getSelectedClientId(): string | null {
        return sessionStorage.getItem(SELECTED_CLIENT_ID_KEY);
    }

    /**
     * Sets the selected client ID
     */
    setSelectedClientId(clientId: string): void {
        sessionStorage.setItem(SELECTED_CLIENT_ID_KEY, clientId);
    }

    /**
     * Removes the selected client ID
     */
    removeSelectedClientId(): void {
        sessionStorage.removeItem(SELECTED_CLIENT_ID_KEY);
    }

    /**
     * Gets the selected client name
     */
    getSelectedClientName(): string | null {
        return sessionStorage.getItem(SELECTED_CLIENT_NAME_KEY);
    }

    /**
     * Sets the selected client name
     */
    setSelectedClientName(clientName: string): void {
        sessionStorage.setItem(SELECTED_CLIENT_NAME_KEY, clientName);
    }

    /**
     * Removes the selected client name
     */
    removeSelectedClientName(): void {
        sessionStorage.removeItem(SELECTED_CLIENT_NAME_KEY);
    }

    /**
     * Clears all data related to "View as Client"
     */
    clearClientViewData(): void {
        this.setViewAsClient(false);
        this.removeSelectedClientId();
        this.removeSelectedClientName();
    }
}

export const clientViewService = new ClientViewService();
